import {
	UserOutline,
	LockOutline,
	GlobalOutline,
	MenuFoldOutline,
	MenuUnfoldOutline,
	BellOutline,
	ShoppingTwoTone,
	DeleteTwoTone,
	EditTwoTone,
	FolderTwoTone,
	TagTwoTone,
	PlusOutline,
	ShoppingCartOutline,
	InboxOutline,
	StarOutline,
	ReadOutline,
	EyeInvisibleOutline,
	ClockCircleTwoTone,
	SettingOutline,
	DeleteOutline,
	FieldTimeOutline,
	HeartOutline,
	DownloadOutline,
	UploadOutline,
	ArrowLeftOutline,
	ArrowUpOutline,
	FireOutline,
	ShoppingOutline,
	BulbOutline,
	ArrowRightOutline,
	PictureTwoTone,
	SafetyOutline
} from "@ant-design/icons-angular/icons";
import { IconDefinition } from "@ant-design/icons-angular";
import { NzIconModule, NZ_ICONS } from "ng-zorro-antd/icon";
import { NgModule } from "@angular/core";

const icons: IconDefinition[] = [
	UserOutline,
	LockOutline,
	GlobalOutline,
	MenuFoldOutline,
	MenuUnfoldOutline,
	BellOutline,
	ShoppingTwoTone,
	TagTwoTone,
	DeleteTwoTone,
	EditTwoTone,
	FolderTwoTone,
	PlusOutline,
	ShoppingCartOutline,
	InboxOutline,
	StarOutline,
	ReadOutline,
	EyeInvisibleOutline,
	ClockCircleTwoTone,
	SettingOutline,
	DeleteOutline,
	FieldTimeOutline,
	HeartOutline,
	DownloadOutline,
	UploadOutline,
	ArrowLeftOutline,
	ArrowUpOutline,
	FireOutline,
	ShoppingOutline,
	BulbOutline,
	ArrowRightOutline,
	PictureTwoTone,
	SafetyOutline
];

@NgModule( {
	imports: [
		NzIconModule.forRoot( icons )
	],
	exports: [
		NzIconModule
	],
	providers: [
		{ provide: NZ_ICONS, useValue: icons }
	]
} )

export class NgZorroIconModule { }
